// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6813":"8a35ae6a","7478":"8a35ae6a","8726":"af37404a"}[chunkId] + ".chunk.css";
};